import { FC } from 'react';
import styles from './interactiveAlertDialog.module.scss';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import DialogBox from 'components/Dialoges/DialogBox';
import Button from 'components/FormControl/Button';
import { Props } from './types';

const InteractiveAlertDialog: FC<Props> = ({
  open,
  title,
  containerStyle,
  Body,
  content,
  actions,
  onClose,
}) => (
  <DialogBox open={open} onClose={onClose}>
    <DialogContent className={`${styles.container} ${containerStyle}`}>
      <DialogTitle className={styles.title}>{title}</DialogTitle>
      {Body && <Body />}
      {content && content}
      {actions && (
        <DialogActions className={styles.actionsContainer}>
          {actions?.map((action) => (
            <Button
              key={action.label}
              text={action.label}
              variant={action.variant || 'contained'}
              color={action.color}
              size={action.size || 'small'}
              onClick={() => action.handler()}
              disabled={action.disabled}
              enableLoading={true}
            />
          ))}
        </DialogActions>
      )}
    </DialogContent>
  </DialogBox>
);

export default InteractiveAlertDialog;
